import { Injectable, signal } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  ITriviaRain,
  ITriviaRainForm,
  ITriviaRegular,
  ITriviaRegularForm,
  ITriviaSystemRain,
  ITriviaSystemRegular,
} from './interfaces/trivia.interface';
import { SocketService } from '@core/services/socket.service';
import { ChatService } from '@features/layout/chat/services/chat.service';
import { SessionService } from '@core/services/session.service';

@Injectable({
  providedIn: 'root',
})
export class TriviaService {
  regularTrivia = signal<ITriviaRegular | null>(null);
  rainTrivia = signal<ITriviaRain | null>(null);

  constructor(
    private socketService: SocketService,
    private chatService: ChatService,
    private toastrService: ToastrService,
    private sessionService: SessionService
  ) {
    this.socketService.socket.on(
      'trivia_rain_question',
      (data: ITriviaRain) => {
        this.rainTrivia.set(data);
      }
    );

    this.socketService.socket.on(
      'trivia_rain_fail',
      (data: ITriviaSystemRain) => {
        this.chatService.addSystemChatMessage(data.message);
      }
    );

    this.socketService.socket.on(
      'trivia_rain_end',
      (data: ITriviaSystemRain) => {
        this.chatService.addSystemChatMessage(data.message);
      }
    );

    this.socketService.socket.on(
      'trivia_rain_start',
      (data: ITriviaSystemRain) => {
        this.chatService.addSystemChatMessage(data.message);
      }
    );

    this.socketService.socket.on('trivia_question', (data: ITriviaRegular) => {
      this.regularTrivia.set(data);
    });

    this.socketService.socket.on(
      'trivia_start',
      (data: ITriviaSystemRegular) => {
        this.toastrService.info(data.message, 'System Message', {
          enableHtml: false,
        });
        this.chatService.addSystemChatMessage(data.message);
      }
    );

    this.socketService.socket.on(
      'trivia_fail',
      (data: ITriviaSystemRegular) => {
        this.chatService.addSystemChatMessage(data.message);
      }
    );

    this.socketService.socket.on('trivia_end', (data: ITriviaSystemRegular) => {
      this.chatService.addSystemChatMessage(data.message);
      this.regularTrivia.set(null);
      this.rainTrivia.set(null);
    });
  }

  async createRainTrivia(data: ITriviaRainForm): Promise<any> {
    return await this.socketService.emit('do_a_trivia_rain', {
      ...data,
      balance: this.sessionService.balanceType(),
    });
  }

  async createRegularTrivia(data: ITriviaRegularForm): Promise<any> {
    return await this.socketService.emit('do_a_trivia', {
      ...data,
      balance: this.sessionService.balanceType(),
    });
  }

  async choiceAnswerTriviaRain(data: string): Promise<any> {
    return await this.socketService.emit('answer_trivia_rain', {
      answer: data,
    });
  }

  async choiceAnswerTriviaRegular(data: string): Promise<any> {
    return await this.socketService.emit('answer_trivia', {
      answer: data,
    });
  }
}
